import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import SellHeaderWithStatus from "@components/SellHeaderWithStatus";
import StepTwoCart from "@components/StepTwoCart";
import { currencyFormatter } from "@utils";
import {
  SHOW_SIGN_IN_POPUP_MODAL,
  SHOW_HOW_WOULD_YOU_LIKE_TO_GET_PAID
} from "@constants/actionTypes";
import { defaultAction } from "@actions/defaultAction";
import Helmet from "react-helmet";
import styled from "@emotion/styled";
import MailInStatusBar from "@components/MailInStatusBar";
import DefaultCustomButton from "@modules/Components/DefaultCustomButton";
import loadable from "@loadable/component";
const CardCashSpinner = loadable(() =>
  import(
    /* webpackChunkName: "CardCashSpinner" */ "../components/CardCashSpinner"
  )
);
import "../styles/sell.scss";
import { useDispatch, useSelector } from "react-redux";
import { initAppBrowser } from "@actions/initApp";
import TradeOptionTooltip from "@components/TradeOptionTooltip";

const MainContent = styled.div`
  max-width: 904px;
  margin: 0 auto;
  box-shadow: 0 20px 80px 0 rgba(119, 121, 132, 0.16);
  background-color: #ffffff;
  margin-top: -64px;
  padding-bottom: 30px;
  margin-bottom: 120px;
  min-height: 265px;

  @media (max-width: 1150px) {
    max-width: 804px;
  }
  @media (max-width: 900px) {
    max-width: 746px;
  }
  @media (max-width: 800px) {
    max-width: 500px;
    grid-gap: 20px;
  }
  @media (max-width: 600px) {
    position: relative;
  }
  @media (max-width: 550px) {
    width: 90%;
    margin: 0 auto;
    margin-top: -64px;
    margin-bottom: 115px;
  }
`;

const NoCards = styled.div`
  text-align: center;
  padding-bottom: 32px;

  @media (max-width: 550px) {
    width: 92%;
    margin: 0 auto;
  }
`;

const NoCardsImage = styled.img`
  width: 400px;
  height: auto;
  margin-top: -36px;

  @media (max-width: 450px) {
    width: 100%;
    margin-top: 0px;
  }
`;

const NoCardsHeader = styled.div`
  font-size: 24px;
  line-height: 1.63;
  color: #1f2021;
  margin-top: -60px;
  margin-bottom: 15px;

  @media (max-width: 340px) {
    margin-top: -35px;
  }
`;

const NoCardsText = styled.div`
  font-size: 16px;
  line-height: 2.25;
  color: #777984;
  margin-bottom: 40px;
`;

const AddACard = styled.div`
  width: 203px;
  height: 72px;
  border-radius: 36px;
  box-shadow: 0 9px 18px 0 rgba(31, 32, 33, 0.05);
  background-color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #39c876;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const CardContainer = styled.div`
  padding-top: 30px;

  @media (max-width: 800px) {
    padding-top: 0px;
  }
`;

const Bottom = styled.div`
  width: 92%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;

  @media (max-width: 900px) {
    display: block;
  }
  @media (max-width: 800px) {
    margin-top: 30px;
  }
  @media (max-width: 710px) {
    width: 90%;
  }
  @media (max-width: 520px) {
    grid-template-columns: auto 1fr;
    grid-gap: 40px;
  }
  @media (max-width: 335px) {
    grid-gap: 20px;
  }
`;

const OfferContainer = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #777984;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 35px;

  @media (max-width: 900px) {
    margin-bottom: ${props => (props.tradeOrder ? "35px" : "0px")};
  }
  @media (max-width: 800px) {
    margin-bottom: 35px;
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 400px) {
    font-size: 13px;
    grid-gap: 0px;
  }
  @media (max-width: 325px) {
    font-size: 11px;
    grid-gap: 5px;
  }
`;

const OfferInnerGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.grid};
  grid-gap: 15px;
  align-items: center;
  grid-column: ${props => (props.tradeOrder ? "1/3" : "1/2")};

  @media (max-width: 900px) {
    justify-content: ${props => (props.tradeOrder ? "center" : "flex-start")};
    display: ${props => (props.tradeOrder ? "flex" : "grid")};
  }
  @media (max-width: 800px) {
    justify-content: center;
    display: flex;
    justify-self: flex-start;
    padding-left: 8px;
  }
`;

const PaymentMethod = styled.div`
  font-size: 14px;
  color: #777984;

  @media (max-width: 400px) {
    font-size: 13px;
  }
  @media (max-width: 325px) {
    font-size: 11px;
  }
`;

const MethodHeader = styled.div`
  font-weight: bold;
`;

const MethodType = styled.div`
  font-weight: 500;
`;

const EditSpan = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: #12b2ea;
  margin-left: 10px;
  cursor: pointer;

  @media (max-width: 400px) {
    font-size: 11px;
  }
  @media (max-width: 325px) {
    font-size: 9px;
  }
`;

const TradeImageContainer = styled.div`
  @media (max-width: 500px) {
    display: none;
  }
`;

const TradeImage = styled.img`
  width: 56px;
  height: 36px;
`;

const ButtonContainer = styled.div`
  justify-self: flex-end;

  @media (max-width: 520px) {
    width: 100%;
  }
`;

const OfferAmount = styled.div`
  font-weight: 500;
`;

const ButtonDiv = styled.div`
  width: 260px;

  @media (max-width: 900px) {
    width: ${props => (props.tradeOrder ? "100%" : "260px")};
  }
  @media (max-width: 800px) {
    width: 100%;
  }
  @media (max-width: 520px) {
    width: 100%;
  }
`;

const Divider = styled.div`
  grid-column: 1/3;
  height: 1px;
  background-color: rgba(119, 121, 132, 0.15);
  margin-bottom: 30px;

  @media (max-width: 800px) {
    display: none;
  }
`;

const Loader = styled.div`
  padding-top: 30px;
`;

const TradeTextDiv = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: auto auto;
  width: fit-content;
  grid-gap: 10px;
`;

const StepTwoSell = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const cards = useSelector(state => state.cards);
  const merchantsSell = useSelector(state => state.merchantsSell);
  const payoutMethod = useSelector(state => state.cartSell.payoutMethod);
  const payoutMethodTradeID = useSelector(
    state => state.cartSell.payoutMethodTradeID
  );
  const tradeBonus = useSelector(state => state.cartSell.tradeBonus);
  const cardIds = useSelector(state => state.cartSell.cardIds);
  const cartId = useSelector(state => state.cartSell.cartId);
  const trade = useSelector(state => state.offers.trade);
  const signedIn = useSelector(state => state.initAppReducer.signedIn);
  const initialSellCartLoading = useSelector(
    state => state.popupsActions.initialSellCartLoading
  );

  const [disabledArray, changeDisabledArray] = useState([]);
  const [disabledState, changeDisabledState] = useState(true);
  const [loading, setLoading] = useState(true);
  const [numAndPinMismatch, changeNumAndPinMismatch] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [loadingInfo, setLoadingInfo] = useState(initialSellCartLoading);

  let theCustomerSignedIn = !!signedIn;

  useEffect(() => {
    dispatch(initAppBrowser(["messages", "sell"]));
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoadingInfo(initialSellCartLoading);
    if (initialSellCartLoading) {
      changeDisabledArray([]);
    }
  }, [initialSellCartLoading]);

  useEffect(() => {
    if (!loading) {
      changeDisabledState(
        checkButtonActive() ||
          !Object.keys(cards).length ||
          disabledArray.find(item => item.disabled) ||
          (Object.keys(numAndPinMismatch) &&
            Object.keys(numAndPinMismatch).find(
              item => numAndPinMismatch[item] === true
            )?.length > 0)
      );
    }
  }, [loading, disabledArray, loadingInfo]);

  const checkButtonActive = () => {
    return Object.keys(cards).find(id => cards[id].serverError);
  };

  const totalPrice = () => {
    return Object.keys(cards).length !== 0
      ? Object.keys(cards).reduce((memo, value) => {
          return Number(memo) + Number(cards[value].cashValue);
        }, 0)
      : 0;
  };

  if (Object.keys(merchantsSell).length === 1) {
    return null;
  }

  const handleArrayChange = obj => {
    const newArray = disabledArray;
    const find = disabledArray.findIndex(item => item.index === obj.index);
    if (find !== -1) {
      newArray.splice(find, 1);
      newArray.push(obj);
    } else {
      newArray.push(obj);
    }
    changeDisabledArray(newArray);
    if (!loading) {
      changeDisabledState(
        checkButtonActive() ||
          !Object.keys(cards).length ||
          newArray.find(item => item.disabled) ||
          (Object.keys(numAndPinMismatch) &&
            Object.keys(numAndPinMismatch).find(
              item => numAndPinMismatch[item] === true
            )?.length > 0)
      );
    }
  };

  let img = null;
  let tradeName = "";
  let tradePriority = "";
  if (payoutMethod === "TRADEOPTION") {
    trade.forEach(offer => {
      if (offer.id === payoutMethodTradeID) {
        img = offer.logo;
        tradeName = offer.name;
        tradePriority = offer.tradePriority;
      }
    });
  }

  let totalCardsVal = totalPrice();
  if (tradeBonus) {
    let valueToAdd;
    totalCardsVal = Number(totalCardsVal);
    valueToAdd = (tradeBonus / 100) * totalCardsVal;
    totalCardsVal += valueToAdd;
    totalCardsVal = totalCardsVal + "";
  }

  const handleContinueButtonClick = () => {
    if (disabledState) {
      setSubmitAttempted(true);
      return;
    }
    if (!payoutMethod) {
      dispatch(defaultAction(SHOW_HOW_WOULD_YOU_LIKE_TO_GET_PAID, "/payout/"));
      return;
    }
    if (!theCustomerSignedIn) {
      dispatch(defaultAction(SHOW_SIGN_IN_POPUP_MODAL, "sellPage"));
    } else {
      history.push("/payout/");
    }
  };

  let paymentMethod;
  switch (payoutMethod) {
    case "MAILCHECK":
      paymentMethod = "Mailed Check";
      break;
    case "ACH":
      paymentMethod = "Direct Deposit";
      break;
    case "PAYPALEXPRESS":
      paymentMethod = "Paypal";
      break;
    case "TRADEOPTION":
      paymentMethod = "Trade-in";
      break;
    default:
      break;
  }
  return (
    <div className="mar-t-128-108">
      <Helmet title="Sell Gift Cards for Cash Online - Up to 92% | CardCash" />
      <SellHeaderWithStatus
        handleContinueButtonClick={handleContinueButtonClick}
        disabledState={disabledState}
      />
      <MainContent>
        {loadingInfo ? (
          <Loader>
            <CardCashSpinner />
          </Loader>
        ) : (
          <>
            {cardIds && Object.keys(cards).length > 0 && cartId ? (
              <div>
                <MailInStatusBar
                  backgroundColor={"rgba(119, 121, 132, 0.16)"}
                />
                <CardContainer>
                  {cardIds.map((card, index) => (
                    <StepTwoCart
                      key={index}
                      cardID={card}
                      changeDisabledArray={handleArrayChange}
                      disabledArray={disabledArray}
                      index={index}
                      setLoading={setLoading}
                      numAndPinMismatch={numAndPinMismatch}
                      changeNumAndPinMismatch={changeNumAndPinMismatch}
                      submitAttempted={submitAttempted}
                      changeStateDisabledArray={changeDisabledArray}
                      disabledArrayItem={disabledArray.find(
                        item => item.index === index
                      )}
                      setLoadingInfo={setLoadingInfo}
                    />
                  ))}
                </CardContainer>
                <Divider />
                <Bottom tradeOrder={img ? true : false}>
                  <OfferContainer tradeOrder={img ? true : false}>
                    {Object.keys(cards).length > 0 && (
                      <>
                        <OfferInnerGrid
                          grid={img ? "56px 1fr" : "1fr"}
                          tradeOrder={img ? true : false}
                        >
                          {img && (
                            <TradeImageContainer>
                              <TradeImage src={img} alt="" />
                            </TradeImageContainer>
                          )}
                          <div>
                            <div>Total 💰</div>
                            <OfferAmount>
                              {img ? (
                                <TradeTextDiv>
                                  <span>
                                    {`Trade-in for ${currencyFormatter(
                                      totalCardsVal
                                    )} ${tradeName}`}
                                  </span>
                                  {trade?.length > 0 && tradePriority > 0 && (
                                    <TradeOptionTooltip />
                                  )}
                                </TradeTextDiv>
                              ) : (
                                `${currencyFormatter(totalCardsVal)} in Cash`
                              )}
                            </OfferAmount>
                          </div>
                        </OfferInnerGrid>
                        {payoutMethod && payoutMethod !== "TRADEOPTION" && (
                          <PaymentMethod>
                            <MethodHeader>Payment Method</MethodHeader>
                            <MethodType>
                              {paymentMethod}
                              <EditSpan
                                onClick={() =>
                                  dispatch(
                                    defaultAction(
                                      SHOW_HOW_WOULD_YOU_LIKE_TO_GET_PAID
                                    )
                                  )
                                }
                              >
                                Edit
                              </EditSpan>
                            </MethodType>
                          </PaymentMethod>
                        )}
                      </>
                    )}
                  </OfferContainer>
                  <ButtonContainer>
                    <ButtonDiv tradeOrder={img ? true : false}>
                      <DefaultCustomButton
                        handleClick={handleContinueButtonClick}
                        disabled={disabledState}
                        classes={"main-default-orange-button"}
                        type="button"
                        buttonType={"GREEN_BUTTON"}
                        name="submit"
                      >
                        <span>Continue</span>
                      </DefaultCustomButton>
                    </ButtonDiv>
                  </ButtonContainer>
                </Bottom>
              </div>
            ) : (
              <NoCards>
                <NoCardsImage
                  src="https://cdn.cardcash.com/website/ui/elements/no-cards-bird.svg"
                  alt=""
                />
                <NoCardsHeader>No cards found</NoCardsHeader>
                <NoCardsText>
                  Please add a card before moving forward with your order.
                </NoCardsText>
                <Link to="/sell-gift-cards/">
                  <AddACard>Add a Card</AddACard>
                </Link>
              </NoCards>
            )}
          </>
        )}
      </MainContent>
    </div>
  );
};

export default StepTwoSell;
